module.exports = __webpack_public_path__ + "static/media/iconEmail.734be66a.svg";